import React from 'react';
import image404 from './404.png'; // Ensure this path is correct
import { NotFoundHeader } from './NotFoundHeader';

function NotFound() {
    return (
        <>
            <NotFoundHeader />
            <div style={{
                width: '100%',
                height: '65dvh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center', // Vertically centers the content
                justifyContent: 'center' // Horizontally centers the content
            }}>
                <img src={image404} alt="404" style={{ width: '50%', height: 'auto' }} />
                <p style={{ fontSize: '20px', fontWeight: 'bold', color: '#D9D9D9', fontFamily: 'Poppins', margin: '50px', padding: 0 }}>Sorry, the page you are looking for could not be found.</p>
            </div>
        </>
    );
}

export default NotFound;
